export class RockItApiConfig {
    public apiUri: string;
    public backendUri: string;
    public reconnectIntervalMs = 5000;
    constructor(backendUri: string) {
        this.apiUri = backendUri + "/api";
        this.backendUri = backendUri;
    }
}
